import React from "react";
import ReactMarkdown from "react-markdown";
import { useIsSmallScreen } from "../../App";
import { Padding } from "../../shared-components/Padding";
import { RUBRIC_COLOR, TEXT_INDENT, TEXT_SIZE } from "../../tokens";
import { SettingsButton, SettingsPanelId } from "./SettingsButton";

export const Rubric: React.FC<{
    settingsPanelId?: SettingsPanelId;
    content: string;
}> = (props) => {
    const { content, settingsPanelId } = props;

    const isSmallScreen = useIsSmallScreen();

    return (
        <Padding onlySides>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                }}
                className="rubric"
                data-content={content}
            >
                {settingsPanelId ? (
                    <div style={{ width: 24, height: 24 }}></div>
                ) : (
                    <></>
                )}
                <div
                    style={{
                        paddingLeft: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        paddingRight: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        color: RUBRIC_COLOR,
                        fontSize: isSmallScreen ? TEXT_SIZE * 0.9 : TEXT_SIZE,
                        textAlign: "center",
                        flexGrow: 1,
                        paddingTop: 8,
                        paddingBottom: 8,
                    }}
                >
                    <ReactMarkdown>
                        {("❡__" + content)
                            .replace(/\\n/g, "  \n")
                            .replace(/_/g, "\u00a0")}
                    </ReactMarkdown>
                </div>
                {settingsPanelId ? (
                    <SettingsButton settingsPanelId={settingsPanelId} />
                ) : (
                    <></>
                )}
            </div>
        </Padding>
    );
};
